import React, { FC, useMemo } from "react";
import Preview from "react-credit-cards";
import "react-credit-cards/es/styles-compiled.css";
import { Stripe as ServerStripe } from "stripe";
import styled from "styled-components";

interface CardDetails {
  name: string;
  expiry: string;
  number: string;
  cvc: string;
  issuer?: string;
}

interface Props {
  card?: CardDetails;
  paymentMethod?: ServerStripe.PaymentMethod | string;
}

const Container = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const CardPreviewLarge: FC<Props> = (props) => {
  const { paymentMethod } = props;

  const card: CardDetails = useMemo(() => {
    if (typeof paymentMethod === "string") {
      return null;
    }

    return (
      props.card || {
        name: paymentMethod.billing_details.name,
        expiry: `${paymentMethod.card.exp_month}/${paymentMethod.card.exp_year}`,
        issuer: paymentMethod.card.brand,
        number: `**** **** **** ${paymentMethod.card.last4}`,
        cvc: "000",
      }
    );
  }, [props.card, paymentMethod]);

  return (
    <Container>
      <Preview preview={!!props.paymentMethod} {...card} />
    </Container>
  );
};
